import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import dynamic from "next/dynamic";

const LiveRtpHome = dynamic(() => import("./LiveRtpHome"));

const LiveRtp: FC<LiveRtpProps> = (props) => {
  const isLiveRtpEnabled = useFeature("rtpLive");
  if (!isLiveRtpEnabled) {
    return null;
  }
  return <LiveRtpHome {...props} />;
};

export default LiveRtp;
